import { resolveMediaUrl } from '@/utils/adminApiHelpers'

const DEMO_NAME_PATTERNS = [/ptnb\s*fitness/i, /^demo\s/i, /^test\s/i]

export function isDemoDisplayName(name) {
  const value = String(name || '').trim()
  if (!value) return true
  return DEMO_NAME_PATTERNS.some(pattern => pattern.test(value))
}

export function filterDemoRecords(records, nameKey = 'name') {
  if (!Array.isArray(records)) return []
  return records.filter(item => !isDemoDisplayName(item?.[nameKey]))
}

export function getUserDisplayName(user = {}) {
  if (!user || typeof user !== 'object') return 'Admin'
  const full = [user.f_name, user.l_name].filter(Boolean).join(' ').trim()
  return user.fullName || full || user.username || user.name || user.email || 'Admin'
}

export function getUserAvatarUrl(user = {}) {
  const raw = user.image || user.profile_image || user.avatar || user.photo
  return raw ? resolveMediaUrl(raw) : ''
}

export function getUserInitials(user = {}) {
  const name = getUserDisplayName(user)
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
  return name.slice(0, 2).toUpperCase()
}
